import React, { useState, useEffect } from "react";
import "./MobileHeader.css";
import { Modal, Button } from "react-bootstrap";
import { logoUrl } from "../../Utils/StaticURLs";
import { getSchoolName, getSchoolLocation } from "../../Utils/Utils";
import { ExistStoreBuilderModal } from "../modals/ExistStoreBuilderModal";
const Header = (props) => {
    const [schoolName, setSchoolName] = useState();
    const [schoolLoc, setSchoolLoc] = useState();
    const [existStoreBuilderModalShow, setexistStoreBuilderModalShow] = useState(false);
    const [startPopUp, setStartPopUp] = useState({
        heading: "",
        body: "",
        popFlag: false,
    });
    const [iconFlag, seticonFlag] = useState(false);

    const handlePopUp = () => {
        seticonFlag(true);
        setStartPopUp({
            heading: props.startOver && props.startOver.title,
            body: props.startOver && props.startOver.info,
            popFlag: true,
        });
    };
    const handleModelHide = () => {
        seticonFlag(false);
        setStartPopUp({ popFlag: false });
    };
    const handleRefresh = () => {
        let origin = window.location.href.split('?')[0];
        window.open(origin, "_self");
    };
    useEffect(() => {
        setSchoolName(getSchoolName());
        setSchoolLoc(getSchoolLocation());
    }, []);
    return (
        <>
            <div>
                <div>
                    <a href="/" id="jos-logo">
                        <img src={logoUrl} alt="Jostens" />
                    </a>
                    <p className='headerIcons'>
                        <span id="start-over-btn" className="cursor-pointer" onClick={() => handlePopUp()}>
                            <i className="fas fa-undo"></i>
                        </span>
                        <span
                            id="exit-builder-btn" className="cursor-pointer"
                            onClick={() => setexistStoreBuilderModalShow(true)}
                        >
                            <i class="fas fa-times"></i> &nbsp;
                    </span>
                    </p>     
                    <div >
                        <div className="headerMobile">
                                {" "}
                                {schoolName ? schoolName : ""}
                                {" "}
                                {schoolLoc ? schoolLoc : ""}
                            <br/>
                            <div>
                            <span className="mobile-headerLeft">
                                {props.selectedStage === "stole-design"
                                    ? props.data.builderName
                                    : `${(props.data && props.data.builderVariantPrefix) || ""} ${props.selectedTemplate !== null
                                        ? (props.selectedTemplate &&
                                            props.selectedTemplate.product &&
                                            props.selectedTemplate.product.templateVariant &&
                                            props.selectedTemplate.product.templateVariant.toUpperCase() +
                                            " " +
                                            props.data.version) ||
                                        ""
                                        : null
                                    } `}
                            </span>
                                <span className='mobile-headerRight'>
                                    {props.selectedStage !== "stole-design" ?
                                        <span>
                                            ${props.estimatedPrice && props.estimatedPrice.toFixed(2)}{" "}
                                        </span> : ''}
                                </span>
                            </div>
                        </div>                   
                    </div>
                </div>
            </div>
            <Modal
                id="modal"
                onHide={() => handleModelHide()}
                show={iconFlag}
                dialogClassName= "modal-md modal-box"
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header id="modalHeader" closeButton>
                    <h4>{startPopUp.heading }</h4>
                </Modal.Header>
                <Modal.Body>
                        <div id="startOverDiv">
                            <p> {startPopUp.body} </p>
                        </div>
                </Modal.Body>
                <Modal.Footer>
                        <div>
                            <Button
                                variant="white"
                                className="modal-btn"
                                onClick={() => handleRefresh()}
                                id="startOverButton"
                            >
                                {props.startOver && props.startOver.leftBtn}
                            </Button>
                            <Button
                                variant="white"
                                className="modal-btn"
                                onClick={() => handleModelHide()}
                                id="continueButton"
                            >
                                {(props.startOver && props.startOver.rightBtn) || ""}
                            </Button>
                        </div>
                </Modal.Footer>
            </Modal>
            <ExistStoreBuilderModal
                show={existStoreBuilderModalShow}
                onHide={() => setexistStoreBuilderModalShow(false)}
                saveto={() => {
                    props.saveDesignFromModalShow(true);
                    setexistStoreBuilderModalShow(false);
                }}
                exitstorejsontext={props.exitStoleAlert}
            />
           </>
    );
};
export default Header;
